const useErrorStore = (set) => ({
  isErrorLoading: false,
  errorConfig: '',
  setIsErrorLoading: (isErrorLoading) => set({ isErrorLoading }),
  setErrorConfig: (errorConfig) => set({ errorConfig }),
});

export default useErrorStore;
